export default __webpack_public_path__ + "5defb9d862279e40f82b0bada811875e.png";